module.exports = __webpack_public_path__ + "img/individual-meter-water-meter-hot-sm.e6b13f03.svg";